



























































































































import Vue from "vue";

import {
  DeployModelTemplateDTO,
  GatewayServiceProxy,
  IotAppModelTemplateServiceProxy,
  IotAppServiceProxy, ListResultVOOfGatewayVO,
  PageGatewayDTO,
  PageRequestDTO,
} from "@/service-proxies/app-v2/iot-console.service-proxies";
import { getUserInfo } from "@/utils/auth";
import {
  MachineServiceProxy,
  WorkStationIotDTO,
  WorkStationNewIotServiceProxy,
  MachineFeatureVO,
  WorkStationIotServiceProxy, BindMachineIotDTO, MachineIotServiceProxy,
} from "@/service-proxies/app-v2/workStation.service-proxies";
import {
  BindFeatureDTO, ExtranetSettingServiceProxy,
  GatewayExtranetServiceProxy,
  GetFeatureVo
} from "@/service-proxies/app-v2/extranet.service-proxies";

const gatewaySrvProxy = new GatewayServiceProxy();
const appSrvProxy = new IotAppServiceProxy();
const wsiSrvProxy = new WorkStationIotServiceProxy();
const appTemplateSrvProxy = new IotAppModelTemplateServiceProxy();
const machineSrvProxy = new MachineServiceProxy();
const gatewayExtranetSrvProxy = new GatewayExtranetServiceProxy();
const machineIotSrvProxy = new MachineIotServiceProxy();
const extranetSettingSrvProxy: ExtranetSettingServiceProxy = new ExtranetSettingServiceProxy();

let timeout;
let currentValue;

const dataCollection=1;
const remoteConnection=2;

/**
 * 机床网关功能，如果已经绑定了采集功能，则采集功能不可选择，如果连接功能已存在，则连接功能不可选择。
 * 采用二进制位算法
 * 0011=3，表示采集功能和连接功能都存在,都不可选择
 * 0010=2，表示数据远程连接已存在,不可选择
 * 0001=1，表示数据采集功能已存在,不可选择
 * dataCollectionDisabled 计算属性表示采集功能是否禁用，true禁用，false不禁用
 * remoteConnectionDisabled 计算属性表示连接功能是禁用，true禁用，false不禁用
 */
export default Vue.extend({
  props: {
  },
  data() {
    return {
      type: 1, //1：选择采集功能  2：选择连接功能
      status: 0, //1：采集功能存在 2：连接功能存在 3：均存在
      visible: false,
      loading: true,
      labelCol: { span: 8 },
      wrapperCol: { span: 13 },
      rules: {
        gatewayId: [
          { required: true, message: this.$t('page_ops_machine_bind_iot_gateway_list_required'), trigger: "blur" },
        ],
        templateId: [
          { required: true, message: this.$t('page_ops_machine_bind_iot_collection_settings_required'), trigger: "blur" },
        ],
      },
      record: {
        feature: "1",
        deviceIp: "192.168.1.101",
        devicePort: 49200
      },

      gatewayCode: undefined,
      gatewayId: undefined,
      appCode: undefined,
      appId: undefined,
      templateId: undefined,

      saving: false,
      machineId: undefined,
      machineCode: undefined,
      iotInfo:{
        id: undefined,
        code: undefined
      },
      gatewayList: [],
      appList: [],
      templateList: [],
    };
  },
  computed: {
    disTitle() {
      return this.$t('page_ops_machine_add_iot_feature');
    },
    // 二进制位运算,参考类注释
    dataCollectionDisabled() {
      return (this.status & dataCollection) === dataCollection;
    },
    // 二进制位运算,参考类注释
    remoteConnectionDisabled(){
      return (this.status & remoteConnection) === remoteConnection;
    }
  },
  methods: {
    collect() {
      this.record.feature = "1";
      this.type = 1;
    },
    connect() {
      this.type = 2;
      this.record.feature = "2";
    },
    initGatewayList$(){
      return gatewaySrvProxy.findAssignableGatewayList().then((res) => {
        this.gatewayList = res.items;
      });
    },
    initAppTemplate$() {
      const templateDto = new PageRequestDTO();
      templateDto.size = -1;
      templateDto.current = -1;
      return appTemplateSrvProxy.pageModelTemplate(templateDto).then((res) => {
        this.templateList = res.items;
      });
    },
    initFeature$(id: string){
      return machineSrvProxy.feature(id).then((res: MachineFeatureVO)=>{
        console.log('init feature collection', res);
        // 位运算,详细见类注释
        if(res.hasDataCollection){
          this.status=(this.status | dataCollection);
        }

        if(res.hasRemoteConnection){
          this.status=(this.status | remoteConnection);
        }
      });
    },
    initIotInfo$(id:string){
      return wsiSrvProxy.getIotsByWorkstationId(id)
          .then((workStationIotRes) => {
            if (workStationIotRes.length <= 0) {
              return
            }
            const iot = workStationIotRes[0]
            this.iotInfo.id = iot.iotId;
            this.iotInfo.code = iot.iotCode;

            if(this.iotInfo.id){
              this.gatewayCode = iot.iotCode;
              this.gatewayId = iot.iotId;

              this.gatewayList.push({
                id:this.iotInfo.id,
                code:this.iotInfo.code
              });
              this.record.gatewayId=this.iotInfo.id;
              this.handleGatewaySelect();
            }
          });
    },
    async initIpInfo(machineId){
      const setting = await extranetSettingSrvProxy.getExtranetSetting();
      const defaultIp = setting.ip || "192.168.1.101";
      const defaultPort = 49200;
      if((this.status & dataCollection) !== dataCollection ){
        this.record.deviceIp = defaultIp;
        this.record.devicePort = defaultPort;
        return ;
      }

      const machineIot = await machineIotSrvProxy.getDetail(machineId);

      if(machineIot==null){
        this.record.deviceIp = defaultIp;
        this.record.devicePort = defaultPort;
        return;
      }

      if(!this.record){
        this.record = {
          deviceIp: machineIot.deviceIp||defaultIp,
          devicePort: machineIot.devicePort||defaultPort,
          templateId: machineIot.templateId || undefined
        }
      }
      else{
         this.record.deviceIp= machineIot.deviceIp||defaultIp;
         this.record.devicePort= machineIot.devicePort||defaultPort;
         this.record.templateId= machineIot.templateId || undefined;
      }

      this.templateId = this.record.templateId;
    },
    open(id: string, code: string) {
      this.loading = true;
      this.visible = true;
      this.type=1;
      this.status=0;

      this.record = {
        feature: "1",
        deviceIp: "192.168.1.101",
        devicePort: 49200
      };

      this.iotInfo = {
        id: undefined,
        code: undefined,
      }

      this.gatewayCode= undefined;
      this.gatewayId= undefined;
      this.appCode= undefined;
      this.appId= undefined;
      this.templateId= undefined;

      this.machineId = id;
      this.machineCode = code;
      const dto = new PageGatewayDTO();
      dto.current = 1;
      dto.size = 100;
      dto.hasWorkStation = false;
      dto.tenantId = this.getTenantId();

      Promise.all([this.initGatewayList$(),
                  this.initAppTemplate$(),
                  this.initFeature$(id),
                  // this.initConnectFeature$(id),
                  this.initIotInfo$(id)])
        .then(res=>{
          return this.initIpInfo(id);
        })
          .then(res=>{
            console.log('初始化成功');
          })
      .catch(err=>{
        this.$message.error(this.$t('page_ops_machine_bind_iot_init_data_failed'));
      }).finally(()=>{
        this.loading=false;
      });

    },
    getTenantId() {
      const info = getUserInfo();
      return info.tenant_id || "";
    },
    handleTemplateSelect(){
      console.log('template select', this.record);
      this.templateId = this.record.templateId;
    },
    handleGatewaySelect() {
      this.gatewayId=this.record.gatewayId;

      const selectedGateway = this.gatewayList.find(
        (c) => c.id === this.record.gatewayId
      );
      if (!selectedGateway) {
        this.$message.error("selectedGateway is null");
        return;
      }
      this.gatewayCode = selectedGateway.code;
      appSrvProxy
        .getIotAppList("", selectedGateway.code, undefined)
        .then((res) => {
          this.appList = res.items.filter((c) => c.code != 0);
          if (this.appList.length < 1) {
            this.$message.error(this.$t('page_ops_machine_bind_iot_no_app'));
          }
          this.record.appId = this.appList[0].id;
          this.appId = this.record.appId;
          this.appCode=this.appList[0].code;
        });
    },
    saveDataCollection(){
      if(this.dataCollectionDisabled){
        this.$message.error(this.$t('page_ops_machine_bind_iot_repeat'));
        return;
      }
      this.$refs.bindIotForm.validate((valid) => {
        if (valid) {
          this.saving = true;

          const input:BindMachineIotDTO = new BindMachineIotDTO();
          input.appCode=this.appCode;
          input.appId = this.appId;
          input.gatewayCode=this.gatewayCode;
          input.gatewayId = this.gatewayId;
          input.templateId=this.templateId;
          input.workStationId=this.machineId;
          input.featureValue=1;
          input.deviceIp = this.record.deviceIp;
          input.devicePort = this.record.devicePort;
          machineSrvProxy.bindIot(input)
            .then(res=>{
              return appSrvProxy.startIotApp(this.gatewayCode,this.appCode);
            }).then(res=>{
                this.$message.success(this.$t('save_success'));
                this.visible = false;
                this.$emit("save");
              })
            .finally(()=>{
              this.saving=false;
            })

        } else {
          return false;
        }
      });
    },
    saveConnectFeature(){

      const inputMachine:BindMachineIotDTO = new BindMachineIotDTO();
      inputMachine.appCode=this.appCode;
      inputMachine.appId = this.appId;
      inputMachine.gatewayCode=this.gatewayCode;
      inputMachine.gatewayId = this.gatewayId;
      inputMachine.templateId=this.templateId;
      inputMachine.workStationId=this.machineId;
      inputMachine.featureValue=2;
      machineSrvProxy.bindIot(inputMachine)
      .then(res=>{
        const input: BindFeatureDTO = new BindFeatureDTO();
        input.workStationId=this.machineId;
        input.gatewayCode=this.gatewayCode;
        return gatewayExtranetSrvProxy.bindFeature(input)
      }).then(res=>{
          this.$message.success(this.$t('save_success'));
          this.visible = false;
          this.$emit("save");
        });
    },
    save() {
      if(this.type===1){
        this.saveDataCollection();
        return ;
      }

      this.saveConnectFeature();


    },
  },
});
